export {default as blob} from "./src/blob";
export {default as buffer} from "./src/buffer";
export {default as dsv, csv, tsv} from "./src/dsv";
export {default as image} from "./src/image";
export {default as json} from "./src/json";
export {default as text} from "./src/text";
export {default as xml, html, svg} from "./src/xml";



//////////////////
// WEBPACK FOOTER
// ../~/d3-fetch/index.js
// module id = UkWT
// module chunks = 0